import { useMemo } from "react";
import { MaterialTransferido } from "../interfaces";
import { MRT_ColumnDef } from "material-react-table";

import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import CustomCantidadInput from "../components/ui/CustomCantidadInput";
import { Delete } from "@mui/icons-material";

import { IconButton, Tooltip, Typography } from "@mui/material";
import CustomPrecioInput from "../components/ui/CustomPrecioInputProps";
import { toast } from "react-toastify";


export const useTableColumnsOrdenCompra = () => {
  const handleActualizarProducto = useCargarSeriesProductos(s => s.handleActualizarProducto)
  const handleEliminarProdcuto = useCargarSeriesProductos(s => s.handleEliminarProducto)


  const columnsInfoProducto = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [

    {
      accessorKey: 'total',
      header: 'Subtotal',
      Cell: ({ row }) => {
        const precio = (Number(row.original.cantidad) * Number(row.original.precio_compra)).toFixed(4)

        return (
          <>
            <Typography>{precio} $</Typography>
          </>
        )
      }
    },
    {
      accessorKey: 'Subtotal_descuento',
      header: 'SubTotal con Descuento',
      Cell: ({ row }) => {
        const precio = (Number(row.original.cantidad) * Number(row.original.precio_compra) - Number(row.original.descuento)).toFixed(4)

        return (
          <>
            <Typography>{precio} $</Typography>
          </>
        )
      }
    }


  ], [])
  const columnsOrdenCompra = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'accion',
      header: 'Accion',
      size: 100,
      Cell: ({ row }) => {
        return (
          <Tooltip title="Eliminar">
            <IconButton
              onClick={() => {
                handleEliminarProdcuto(row.original.id)
              }}
            >
              <Delete /* color="error" */ />
            </IconButton>

          </Tooltip>

        )
      }
    },
    {
      accessorKey: 'cantidad_aprobada',
      header: 'Cant. Aprobada',
      size: 147
    },
    {
      accessorKey: 'cantidad_pendiente',
      header: 'Cant. Pendiente por Comprar',
    },
    {
      accessorKey: 'cantidad',
      header: 'Cant. A Comprar',
      size: 155,
      Cell: ({ row }) => (
        <CustomCantidadInput<MaterialTransferido>
          value={row.original.cantidad}
          handleValue={(value) => {
            handleActualizarProducto(row.original.id, {
              ...row.original,
              cantidad: value,
            })
          }}
          row={row}
        />
      )
    },
    {
      accessorKey: 'precio_compra',
      header: 'Valor unitario',
      Cell: ({ row }) => (
        <CustomPrecioInput<MaterialTransferido>
          value={row.original.precio_compra!}
          handleValue={(value) => {
            handleActualizarProducto(row.original.id, {
              ...row.original,
              precio_compra: value,
            })
          }}
          row={row}
        />
      )
    },
    {
      accessorKey: 'descuento',
      header: 'Descuento',
      Cell: ({ row }) => (
        <CustomPrecioInput<MaterialTransferido>
          value={row.original.descuento!}
          handleValue={(value) => {
            const subtotal = Number(row.original.cantidad) * Number(row.original.precio_compra)
            if (Number(value) > subtotal) {
              toast.error(`El descuento (${value}) no puede ser mayor que el subtotal (${subtotal}).`)
              handleActualizarProducto(row.original.id, {
                ...row.original,
                descuento: subtotal.toString()
              })
              return

            }
            handleActualizarProducto(row.original.id, {
              ...row.original,
              descuento: value
            })
          }}
          row={row}
        />
      )
    },
    {
      accessorKey: 'ultimo_precio_compra',
      header: 'Ultimo Precio Compra',
    },
    {
      accessorKey: 'producto_data.descripcion',
      header: 'Descripción'
    },
    {
      accessorKey: 'codigo',
      header: 'Codigo'
    },
    /*{
        accessorKey: 'Cant. Quedarán Pendiente',
        header: 'Cant. Quedarán Pendiente',
        size: 150,
        Cell: ({ row }) => {
          const cantidad = Number(row.original.cantidad)
          const cantidadPendiente = Number(row.original.cantidad_pendiente)
          const cantidadTotal = cantidadPendiente - cantidad
          return (
            <>
              <Typography>{cantidadTotal}</Typography>
            </>
          )
        }
      }, */
    /*  {
       accessorKey: 'cantidad_pendiente',
       header: 'Cant. Pendiente Actual',
     }, */
    {
      accessorKey: 'producto_data.stock_actual',
      header: "Stock Actual"
    },
    /* {
      accessorKey: 'cantidad_aprobada',
      header: 'Cant. Aprobada',
      size: 147
    }, */

    ...columnsInfoProducto
  ], [])
  return {
    columnsOrdenCompra
  }
}
export default useTableColumnsOrdenCompra;